import { render } from "./uploadPlanilhaLubrificanteTransmissao.vue?vue&type=template&id=183823f7&scoped=true&ts=true"
import script from "./uploadPlanilhaLubrificanteTransmissao.vue?vue&type=script&lang=ts"
export * from "./uploadPlanilhaLubrificanteTransmissao.vue?vue&type=script&lang=ts"

import "./uploadPlanilhaLubrificanteTransmissao.vue?vue&type=style&index=0&id=183823f7&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-183823f7"]])

export default __exports__